import Request from './request'

const Device_Snapshot = {
  takeDeviceSnapshot (id, params, callback) {
    Request.post('device-snapshot/take/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceSnapshotsList(id, page, callback) {
    Request.get('device-snapshot/' + id + '/list/' + page).then(callback).catch(this.bad_answer)
  },
  getDeviceSnapshot (id, callback) {
    Request.get('device-snapshot/view/' + id).then(callback).catch(this.bad_answer)
  },
}
export default Device_Snapshot
